export default __webpack_public_path__ + "static/media/withdrawal-dollar-icon.f66781ed.png";